var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MenuButton',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom.hover",value:(_vm.tooltipTitle),expression:"tooltipTitle",modifiers:{"bottom":true,"hover":true}}],attrs:{"btn-key":_vm.btnKey},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }